import { render } from "./TabFiles.vue?vue&type=template&id=5cca203e"
import script from "./TabFiles.vue?vue&type=script&lang=js"
export * from "./TabFiles.vue?vue&type=script&lang=js"
script.render = render

export default script